/* eslint-disable no-console */
import clc from 'cli-color'
import { Platform } from 'react-native'
import * as Sentry from "../sentry"

const LOG_LEVELS = {
  EMERG: { val: 0, label: 'EMERG', color: clc?.magentaBright },
  ALERT: { val: 1, label: 'ALERT', color: clc?.magentaBright },
  CRIT: { val: 2, label: 'CRIT', color: clc?.redBright },
  ERROR: { val: 3, label: 'ERROR', color: clc?.redBright },
  WARN: { val: 4, label: 'WARN', color: clc?.xterm(208) }, // orange
  NOTICE: { val: 5, label: 'NOTICE', color: clc?.yellowBright },
  VERBOSE: { val: 6, label: 'VERBOSE', color: clc?.cyanBright },
  INFO: { val: 6, label: 'INFO', color: clc?.cyanBright },
  DEBUG: { val: 7, label: 'DEBUG', color: clc?.greenBright }
}

// _c short for context
const _context = (): string => {
  const { stack } = new Error()
  const depth = 4

  try {
    const arr = stack.split('\n')
    const chunks = arr[depth].split('/')
    const business = chunks[chunks.length - 1] // ha ha!
    const matches = business.match(/^([^:]+):(\d+):(\d+)/i)

    const filename = matches[1]
    const line = matches[2]
    const pos = matches[3]

    // return { filename, line, pos }
    return `[${filename}:${line}:${pos}]`
  } catch (ex) {
    Sentry.captureException(ex, { level: 'warning' })
  }
}

const maybeReport = (...args: any): void => {
  const [err, opts] = args

  // if it looks like an error, it's probably an error
  if (err?.stack && err?.message) {
    Sentry.captureException(err, opts)
  }
}

export class Log {
  static debug(...args: any): void { this._log('DEBUG', ...args) }
  static info(...args: any): void { this._log('INFO', ...args) }
  static verbose(...args: any): void { this._log('VERBOSE', ...args) }
  static notice(...args: any): void { this._log('NOTICE', ...args) }
  static warn(...args: any): void { this._log('WARN', ...args) }
  static error(...args: any): void { 
    this._log('ERROR', ...args)
    maybeReport(...args)
  }
  static crit(...args: any): void { 
    this._log('CRIT', ...args)
    maybeReport(...args)
  }
  static alert(...args: any): void { 
    this._log('ALERT', ...args)
    maybeReport(...args)
  }
  static emerg(...args: any): void { 
    this._log('EMERG', ...args) 
    maybeReport(...args)
  }
  
  private static _log(level: string, ...args: any): void {
    // if (this._level >= LOG_LEVELS[level].val) {
      const dt = new Date().toISOString()
      const ctx = _context()
      let label = LOG_LEVELS[level].label
      if (Platform.OS !== 'web') {
        label = LOG_LEVELS[level].color(label)
      }

      const lvl = level.toLowerCase()
      const f = typeof console[lvl] === 'function' ? console[lvl] : console.log
    
      f(dt, label, ctx, ...args)
    // }
  }
}

export const log = Log

export default Log
